// @flow
import * as React from 'react';
import { useJSSStyles } from '../../jss-hooks';
import { type JSSThemeType } from '../../origins/JSSThemeDefault';
const path = (theme: JSSThemeType) => theme.components.Geoblock;

export const GeoblockPage61900 = () => {
  const classes = useJSSStyles(path);
  return (
    <div className={classes.rootGeoblock}>
      <div className={classes.logoGeoblock}>
        <img
          src="https://cdn.uzbekbet.com/images/nbet_logo.png"
          alt="logo"
          className={classes.imgGeoblock}
        />
      </div>
      <div className={classes.textGeoblock}>{_t('site-is-geoblocked')}</div>
    </div>
  );
};
